import styled, { css } from 'styled-components';
import { baseStyles, baseProps } from './base.style';
import { RowChild } from './row-child.style';
import { RowBuffer } from './row-buffer.style';
import { containerStyles, containerProps } from './container.style';
import { breakpointStyles, border, getPropTypes } from './utils';

const rowHoverStyles = props =>
  props.onClick &&
  css`
    &:hover {
      background: ${props => props.theme.colors.background.secondary};
      cursor: pointer;
      ${RowBuffer} {
        border-top: 1px solid ${props => props.theme.colors.background.tertiary};
        border-bottom: 1px solid
          ${props => props.theme.colors.background.tertiary};
      }
      &:last-child {
        ${RowChild} {
          margin-bottom: -1px;
          border-bottom: 1px solid
            ${props => props.theme.colors.background.tertiary};
        }
      }
    }
  `;

export const Row = styled.li<StyleProps>`
  ${baseStyles}
  ${containerStyles}
  ${border}
  ${rowHoverStyles}


  ${props =>
    !props.hideTopBorder &&
    `
    ${RowChild} {
      border-top: 1px solid ${props.theme.colors.background.tertiary};
    }`}

  ${props =>
    props.hasBottomBorder &&
    `
    ${RowChild} {
      border-bottom: 1px solid ${props.theme.colors.background.tertiary};
      margin-bottom: -1px;
    }
  `}

  ${breakpointStyles(baseStyles)}
  ${breakpointStyles(containerStyles)}
  ${breakpointStyles(border)}
`;

export const listProps = {
  ...baseProps,
  ...containerProps,
};

Row.propTypes = getPropTypes(listProps);

Row.defaultProps = {
  alignItems: 'center',
  flex: true,
  justifyContent: 'space-between',
  width: '100%',
};
